<template>
  <v-sheet class="pa-2 ma-2">
    <div class="number-box">
      <transition name="fade-bounce" mode="out-in">
        <div :key="label + '-' + numberBoxKeyIndex">
          <span class="large-number">{{ (number && Intl.NumberFormat().format(number)) || '-' }}</span>
          <span class="percentage-number" v-if="percentageNumber">&nbsp;
          {{ percentageNumber }}%
          </span>
        </div>
      </transition>
      <div class="label large-number-label">{{ label }}</div>
      <div class="label large-number-comment" v-if="comment">{{ comment }}</div>
    </div>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'NumberBox',
  props: {
    number: Number,
    percentageNumber: {
      type: Number,
      default: undefined
    },
    label: String,
    comment: {
      type: String,
      default: undefined
    }
  },
  data: () => ({
    numberBoxKeyIndex: 0
  }),
  methods: {
    forceRerender() {
      this.numberBoxKeyIndex += 1;
    }
  },
  updated() {
    this.forceRerender()
  }
});
</script>

<style scoped>
.number-box {
  height: 375px;
  justify-content: space-around;
  text-align: center;
  padding: 50px;
  margin: 10px;
  flex: 1;
  border-radius: 8px;
  background-color: #364c5b;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 0 0 2px #c0c0c0; /* Elevated border effect */
}

.large-number {
  font-size: 4em;
  font-weight: bold;
}

.large-number-label {
  font-size: 1em;
  margin-top: 10px;
}

.large-number-comment {
  font-size: 0.8em;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
}

.fade-bounce-enter-active {
  transition: all 0.5s ease-in;
  animation: bounce-in 0.5s;
}
.fade-bounce-leave-active {
  transition: all 0.5s ease-out;
  animation: bounce-in 0.5s reverse;
}

.fade-bounce-enter-from,
.fade-bounce-leave-to {
  opacity: 0;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
</style>
